import { render, staticRenderFns } from "./Budjet.vue?vue&type=template&id=9817af2e&scoped=true&"
import script from "./Budjet.vue?vue&type=script&lang=js&"
export * from "./Budjet.vue?vue&type=script&lang=js&"
import style0 from "./Budjet.vue?vue&type=style&index=0&id=9817af2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9817af2e",
  null
  
)

export default component.exports